import { MutationTree } from 'vuex'

export interface DropdownState {
  dropDownOpen: boolean
}

export function state (): DropdownState {
  return ({
  dropDownOpen: false
})
}

export const mutations: MutationTree<DropdownState> = {
  SET_DROPDOWN (state, data: boolean) {
    state.dropDownOpen = data
  }
}
